import { useEffect } from "react";
import { Icon } from "@hireart/component-library";
import alertTriangleIcon from "hireart-icons/alert-triangle.svg";
import PropTypes from "prop-types";
import { Tab } from "semantic-ui-react";
import { Toasts } from "hireart-components";
import "./server-error.scss";

const memoizedFlashErrorMessage = () => {
  let alreadyFlashed = false;

  return () => {
    if (alreadyFlashed) {
      return;
    }
    alreadyFlashed = true;
    Toasts.error("Oops, something went wrong");
  };
};

const errorMessage = memoizedFlashErrorMessage();

const ServerError = ({
  headerText = "Uh-oh — something's not right...",
  message = "Something happened on our end. We're working to fix it as soon as possible — just sit tight and everything should be back up to normal soon. If you'd like, try refreshing the page.",
}) => {
  useEffect(() => {
    errorMessage();
  }, []);

  return (
    <div className="server-error">
      <Tab.Pane>
        <h3 className="title-2 font-semibold">
          <Icon src={alertTriangleIcon} />
          {headerText}
        </h3>
        <p className="description">{message}</p>
      </Tab.Pane>
    </div>
  );
};

ServerError.propTypes = {
  message: PropTypes.string,
  headerText: PropTypes.string,
};

export default ServerError;
